import React from "react";

const VALUE_LABEL = {
  skip: "Ø",
  reverse: "⟲",
  draw2: "+2",
  wild: "★",
  wild4: "+4",
};

export function UnoCardView({ card, size = "md", playable = false, onClick, testId, skin = "classic" }) {
  if (!card) return null;
  const sizeCls = size === "sm" ? "small" : size === "xs" ? "tiny" : size === "lg" ? "large" : "";
  const colorCls = `uno-${card.color}`;
  const label = VALUE_LABEL[card.value] || card.value;
  return (
    <div
      data-testid={testId}
      className={`uno-card skin-${skin} ${sizeCls} ${colorCls} ${playable ? "playable" : ""}`}
      onClick={playable ? onClick : undefined}
      role={playable ? "button" : undefined}
    >
      <div className="corner tl">{label}</div>
      <div className="value">{label}</div>
      <div className="corner br">{label}</div>
    </div>
  );
}

export function UnoCardBack({ size = "md", skin = "classic" }) {
  const sizeCls = size === "sm" ? "small" : size === "xs" ? "tiny" : size === "lg" ? "large" : "";
  return (
    <div className={`uno-card uno-back skin-${skin} ${sizeCls}`}>
      <div className="value">DOS</div>
    </div>
  );
}

export default UnoCardView;
